module.exports = BV.localStorage;